const Category = [
  {
    Paycheck: ["Paycheck"],
    TaxRefund: ["Tax Refund"],
    HandCash: ["HandCash from Thiru", "HandCash From Kandasamy"],
    Cheque_Deposit: ["Cheque Deposit"],
    Other_Income: ["Other Income", "Chess Income"],
    Equity_Investments: ["Equity Investments"],
    Savings: ["Savings"],
    House_Rent: ["House Rent"],
    House_Utilities: ["House Utilities"],
    House_Insurance: ["House Insurance"],
    Edision: ["Edision", "Electricity Bills"],
    Laundry_Expenses: ["Laundry Expenses"],
    Water: ["Water Bill"],
    Groceries: ["Groceries"],
    Food_Expenses: ["Food Expenses"],
    Car_Lease: ["Car Lease"],
    Car_Insurance: ["Car Insurance"],
    Car_Registration_Renewal: ["Car Registration Renewal"],
    Gas_Expenses: ["Gas Expenses"],
    Rebtel: ["Rebtel"],
    Mobile_Bill: ["AT&T Bill", "Mobile Recharge"],
    Internet: ["Internet Bills"],
    Cas_Withdrawal: ["Cash Withdrawal"],
    Transfer: ["Remittance to India"],
    Shopping: ["Shopping", "Target Shopping"],
    Entertainment: ["Entertainment"],
    Passport_Renewal: ["Passport Renewal", "USA Passport Renewal"],
    Grooming: ["Grooming Expenses"],
    Medical_Expenses: ["Pharmacy Expenses", "Medical Expenses"],
    Sports: ["Soccer Fees", "Chess Fees"],
    School: ["Tuition Fees", "PTA School Fees", "Tamil School Fees"],
    HandLoan_Repayment: [
      "Hand Loan Repayment",
      "HandCash Repayment",
      "Refund Hand Loan",
    ],
    IncomeTax: ["Income Tax"],
    OneTimePay: [
      "Cab Expenses",
      "Car Lease Deposit",
      "DMV Fees",
      "Car Wash",
      "Gardening Expenses",
      "Printing Expenses",
      "Cake Expenses",
      "Tax Preparation Fees",
    ],
    Other_Expenses: ["Other Expenses"],
  },
];
export default Category;
